import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/i18n";
import { AuthCallback, ProtectedRoute } from "@/components/AuthGate";
import { SiteLayout } from "@/components/Layout";
import Home from "@/pages/Home";
import GraderPage from "@/pages/GraderPage";
import HouseRulesPage from "@/pages/HouseRulesPage";
import TouristTaxPage from "@/pages/TouristTax";
import { TemplatesPage, TemplateDetail } from "@/pages/Templates";
import { PricingPage, GuidesPage, CountryGuide, ArticleGuide } from "@/pages/Content";
import { LegalPage, HelpPage, LoginPage, PaymentResult, PublicGuidebook } from "@/pages/Misc";
import AppLayout from "@/pages/app/AppLayout";
import Dashboard from "@/pages/app/Dashboard";
import Properties from "@/pages/app/Properties";
import Rewriter from "@/pages/app/Rewriter";
import Messages from "@/pages/app/Messages";
import Guidebooks from "@/pages/app/Guidebooks";
import MyTemplates from "@/pages/app/MyTemplates";
import Outreach from "@/pages/app/Outreach";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/grader" element={<GraderPage />} />
        <Route path="/house-rules" element={<HouseRulesPage />} />
        <Route path="/tourist-tax" element={<TouristTaxPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/:id" element={<TemplateDetail />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/country/:slug" element={<CountryGuide />} />
        <Route path="/guides/:slug" element={<ArticleGuide />} />
        <Route path="/legal/:doc" element={<LegalPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      </Route>
      <Route path="/g/:slug" element={<PublicGuidebook />} />
      <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="properties" element={<Properties />} />
        <Route path="rewriter" element={<Rewriter />} />
        <Route path="messages" element={<Messages />} />
        <Route path="guidebooks" element={<Guidebooks />} />
        <Route path="templates" element={<MyTemplates />} />
        <Route path="outreach" element={<Outreach />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="bottom-right" richColors />
          </AuthProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}
